export default __webpack_public_path__ + "static/media/DJI_0971.MP4.00_04_59_00.Still003.fbb9a007.jpg";